<template>
  <div
    class="row justify-center"
    style="padding-bottom: 120px; mergin-bottom: 50px"
  >
    <TileBar
      class="q-mt-sm"
      title="Your Personal Info"
      :option-button="editable ? 'Save' : 'Edit'"
      @on-button="onEditProfile"
    />
    <div
      class="col-12 col-sm-10 col-md-9 bg-white row"
      style="padding: 6px 16px; position: relative"
      v-if="saleData"
    >
      <div class="full-width row">
        <div
          class="col-3 text-right q-mt-sm"
          style="display: flex; align-items: center; margin-bottom: 20px"
        >
          First name (ชื่อ)
        </div>
        <div class="col-xs-9 col-sm-4 q-mt-sm">
          <!-- {{ sale.firstname }} -->
          <q-input
            :rules="[(val) => !!val || 'firstname is required']"
            :disable="!editable"
            outlined
            dense
            v-model="saleData.firstname"
            ref="input_firstname"
          ></q-input>
        </div>
      </div>
      <div class="full-width row">
        <div
          class="col-3 text-right q-mt-sm"
          style="display: flex; align-items: center; margin-bottom: 20px"
        >
          Last name (นามสกุล)
        </div>
        <div class="col-xs-9 col-sm-4 q-mt-sm">
          <!-- {{ sale.lastname.length === 0 ? "-" : sale.lastname }} -->
          <q-input
            :rules="[(val) => !!val || 'lastname is required']"
            :disable="!editable"
            outlined
            dense
            v-model="saleData.lastname"
            ref="input_lastname"
          ></q-input>
        </div>
      </div>
      <div class="full-width row">
        <div
          class="col-3 text-right q-mt-sm"
          style="display: flex; align-items: center; margin-bottom: 20px"
        >
          Branch (รหัสสาขา)
        </div>
        <div class="col-xs-9 col-sm-4 q-mt-sm">
          <!-- {{ sale.branch }} -->
          <q-input
            :rules="[(val) => !!val || 'branch is required']"
            :disable="!editable"
            outlined
            dense
            placeholder="เช่น 1000 หริอ 1003"
            v-model="saleData.branch"
            ref="input_branch"
          ></q-input>
        </div>
      </div>
      <q-inner-loading :showing="userInfoLoading">
        <q-spinner size="50px" color="primary" />
      </q-inner-loading>
    </div>
  </div>
</template>

<script>
import Auth from '@aws-amplify/auth';
import { mapState } from "vuex";
export default {
  name: "ProfileV2",
  components: {
    TileBar: () => import(`@/ui/components/TileBar`),
  },
  data() {
    return {
      userInfoLoading: false,
      saleData: undefined,
      editable: false,
    };
  },
  computed: {
    //mockup sale data
    // ...mapState({
    //     firstname: (state) => state["sale"]["firstname"],
    //     lastname: (state) => state["sale"]["lastname"],
    //     branch: (state) => state["sale"]["firstname"],
    //     // customers: (state) => state["sale"]["customers"],
    //     // activeCustomerID: (state) =>
    //     //     state["activeCustomer"]["customer"]["id"],
    // }),
    sale() {
      const sale = this.$store.state["sale"];
      if (sale.sale) {
        return {
          firstname: sale.sale.firstname,
          lastname: sale.sale.lastname,
          branch: sale.sale.branch,
        };
      }
      return {
        firstname: "",
        lastname: "",
        branch: "",
      };
    },
  },
  watch: {
    sale: {
      immediate: true,
      handler: function (val) {
        console.log("sale watcher", val);
        this.saleData = val;
      },
    },
  },
  methods: {
    async onEditProfile() {
      console.log("onEditProfile");
      if (!this.editable) {
        this.editable = !this.editable;
        return;
      }
      console.log("save new profile");
      const validFirstname = this.$refs.input_firstname.validate();
      const validLastname = this.$refs.input_lastname.validate();
      const validBranch = this.$refs.input_branch.validate();
      console.log("validate", validFirstname, validLastname, validBranch);
      try {
        const sale = this.$store.state["sale"];
        console.log(sale.sale.id);
        if (validFirstname && validLastname && validBranch) {
          this.$store.dispatch("sale/updateSale", {
            id: sale.sale.id,
            ...this.saleData,
          });
          this.editable = false;

          const userInfo = await Auth.currentUserInfo();
          console.log(userInfo);

          if(userInfo){
              if(userInfo.attributes["custom:branch"] != this.saleData.branch){
                  await this.$services.admin.updateUserAttributes(userInfo.username, "custom:branch", this.saleData.branch);
              }
              if(userInfo.attributes["custom:firstname"] != this.saleData.firstname){
                  await this.$services.admin.updateUserAttributes(userInfo.username, "custom:firstname", this.saleData.firstname);
              }
              if(userInfo.attributes["custom:lastname"] != this.saleData.lastname){
                  await this.$services.admin.updateUserAttributes(userInfo.username, "custom:lastname", this.saleData.lastname);
              }

              await Auth.currentAuthenticatedUser({
                  bypassCache: true
              });
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style>

.otp-input {
  width: 40px;
  height: 40px;
  padding: 5px;
  margin: 0 10px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
  &.error {
    border: 1px solid red !important;
  }
}
.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

</style>

<style scoped>

.sticky-bottom {
  position: fixed;
  bottom: 50px;
  /* left: 0px; */
  /* right: 0px; */
  background-color: #ffffff;
  -webkit-box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.3);
  padding: 16px;
  flex-direction: column-reverse;
  display: flex;
}
.text-term {
  padding: 20px 0 5px;
  text-align: right;
  font-size: 13px;
}

</style>
